import React from 'react';
import { Link } from 'react-router-dom';

import firebase from 'firebase';

class HotelItem extends React.Component {
  componentDidMount() {
    if(this.props.bookedHotel == this.props.hotel.Name) {
      this.setState({bookText: 'Booked!'});
    } else {
      this.setState({bookText: 'Book Deal'});
    }
  }
  state = {
    users: [],
    bookText: 'Book Deal'
  }
  render() {
    let hotel = this.props.hotel;
    let location = this.props.loc;
    let currentUserId = this.props.currentUid;
    let currentUser = this.props.currentUser;
    let currentUserHotel = this.props.bookedHotel;
    let phURL = this.getURL(hotel);
      return(
      <div>
        <div class="hotelList">
          <img src={phURL} alt="Image of a Hotel" align="top"/>
          <div className="book-btn">
            <button id="bookButton" onClick={this.addHotel}>{this.state.bookText}</button>
          </div>
          <div class="hotelListText">
              <span>
                <h2>{hotel.Name}</h2>
                <h3>Price: INR {hotel.Price}</h3>
                <h4>Rating: {hotel.Star}</h4>
                <span className="address">
                  <strong>Address:</strong>
                  <p>{hotel.Add}</p>
                </span>
              </span>
              <span>
                <strong>Facilities:</strong>
                <p>Free Wi-Fi: {hotel.wifi}</p>
                <p>Free Breakfast: {hotel.breakfast}</p>
                <p>Parking: {hotel.parking}</p>
                <p>Spa: {hotel.spa}</p>Pool: {hotel.pool}
              </span>
            </div>
            <div className="other-image">
              <p><strong>Other images:</strong></p>
              <img src={hotel.other1} alt="Other images"/>
              <img src={hotel.other2} alt="Other images"/>
            </div>
        </div>
      </div>
    );
  }
  addHotel = () => {
      if(this.props.currentUid) {
        console.log("Adding Hotel...");
        if(this.checkForHotel(this.props.bookedHotel, this.props.hotel.Name)) {
          console.log("Hotels are matching!");
          alert("You've already booked this one!");
        } else {
          let confirm = null;
          let flag = 0;
            if(this.props.bookedHotel) {
              let cValue = "n"
              let string1 = "y";
              let string2 = "n";
              while(flag == 0) {
                cValue = prompt("Are you sure to cancel your previous booking i.e " + this.props.bookedHotel + "... (Y/N)?");
                console.log(cValue);
                if(cValue == string1.toUpperCase() || cValue == string1) {
                  flag = 1;
                } else if(cValue == string2 || cValue == string2.toUpperCase()) {
                  flag = -1;
                } else if(cValue == null){
                  flag = -1;
                } else {
                  alert("Please re-enter your choice...");
                }
              }
            }
            if(flag == 0 || flag == 1) {
            console.log(flag);
            console.log(this.props.hotel.Name);
            console.log(this.props.currentUid);
            firebase.firestore().collection('users').doc(this.props.currentUid).set({
              email: this.props.currentUser.email,
              name: this.props.currentUser.displayName,
              uid: this.props.currentUser.uid,
              hotel: this.props.hotel.Name,
              checkIn: this.props.checkin,
              checkOut: this.props.checkout,
            })
            .then(function() {
                console.log("Document successfully written!");
            })
            .catch(function(error) {
                console.error("Error writing document: ", error);
            })
            this.setState({bookText: 'Booked!'});
            alert("Booking Success!\nYou booked " + this.props.hotel.Name + " from " + this.props.checkin + " to " + this.props.checkout + "\nYou can view your bookings in the profile page.\nYou can still go through other hotels provided by Sarathi");
            setTimeout(function(){ window.location.reload(); }, 500);
          } else if(flag == -1) {
            alert("Your previous booking is unchanged!")
          }
        }
      }
      else {
        alert("Want to book a hotel..?\nPlease log-in to Sarathi and then try")
      }
    }
  checkForHotel = (userHotel, renderedHotel) => {
    if(userHotel == renderedHotel) {
      this.setState({bookText: 'Booked!'});
      return true;
    } else {
      this.setState({bookText: 'Book Deal'});
      return false;
    }
  }
  getURL = (h) => {
    if(h.photoURL) {
      return h.photoURL;
    }
    else {
      return "../public/title_icon.png"
    }
  }
}

export default HotelItem;
